/* eslint-disable react/no-danger */
import { get } from 'lodash';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import routePaths from 'router/route-paths';
import { formatCurrency } from 'utils/helpers';
import { useQuery } from '@apollo/client/react';
import { MyBudgetMonthlyRateDocument, type ProjectDashboardQuery } from 'graphql/generated/graphql';
import s from './Overview.module.scss';

interface IOverviewProps {
  project: ProjectDashboardQuery['project'];
}

export default function Overview({ project }: IOverviewProps) {
  const { formatMessage: t } = useIntl();
  const { name, price, budget } = project;
  const { data: myBudgetQueryData } = useQuery(MyBudgetMonthlyRateDocument);
  const monthlyRate = get(project, 'loan.monthly_rate', project.financing_rate);
  const loanAmount = get(project, 'loan.amount', project.loan_amount);
  const budgetMonthlyRateLoan = get(
    myBudgetQueryData,
    'myBudget.calculation.monthly_rate_loan.calculated_value',
    null,
  );

  return (
    <div className={s.overviewCol}>
      <h2 className={s.projectName}>{name}</h2>
      <div className={s.grayItem}>
        <h3 dangerouslySetInnerHTML={{ __html: t({ id: 'dashboard.overview.project_price' }) }} />
        <b>{formatCurrency(price)}</b>
      </div>
      <div className={s.grayItem}>
        <h3 dangerouslySetInnerHTML={{ __html: t({ id: 'dashboard.overview.budget' }) }} />
        <b>{formatCurrency(budget)}</b>
      </div>
      <div className={s.grayItem}>
        <h3
          dangerouslySetInnerHTML={{
            __html: t({ id: 'dashboard.overview.monthly_affordable_repayments' }),
          }}
        />
        {budgetMonthlyRateLoan ? (
          <b>{formatCurrency(budgetMonthlyRateLoan)}</b>
        ) : (
          <p className={s.notAvailableValue}>
            {t(
              { id: 'dashboard.overview.budget_monthly_rate_loan' },
              {
                link: (
                  <Link to={routePaths.lifestyleOverview} key={1}>
                    {t({ id: 'dashboard.overview.budget_monthly_rate_loan_link_label' })}
                  </Link>
                ),
              },
            )}
          </p>
        )}
      </div>
      <div className={s.primaryItem}>
        <h3 dangerouslySetInnerHTML={{ __html: t({ id: 'dashboard.overview.loan_amount' }) }} />
        <b>{formatCurrency(loanAmount)}</b>
      </div>
      <div className={s.primaryItem}>
        <h3 dangerouslySetInnerHTML={{ __html: t({ id: 'dashboard.overview.monthly_rate' }) }} />
        <b>{formatCurrency(monthlyRate)}</b>
      </div>
    </div>
  );
}
